import styled from 'styled-components';

import { LINE_HEIGHT_DEFAULT } from 'styles/typography';

import Text from './Text';

const Paragraph = styled(Text)`
  line-height: ${LINE_HEIGHT_DEFAULT};
  overflow: auto;
  top: initial;
  vertical-align: top;
  white-space: normal;
`;

export default Paragraph;
